/**
 * named constants for the type of chart to create.
 */
export enum FnChartType {
	/**
	 * named constant for XYChart
	 */
	XYChart = 'XYChart',
	/**
	 * named constant for PieChart
	 */
	PieChart = 'PieChart',
	/**
	 * named constant for DonutChart
	 */
	DonutChart = 'DonutChart',
	/**
	 * named constant for StackColumnChart
	 */
	StackColumnChart = 'StackColumnChart',
	/**
	 * named constant for ClusterColumnChart
	 */
	ClusterColumnChart = 'ClusterColumnChart',
	/**
	 * named constant for LineChart
	 */
	LineChart = 'LineChart',
}

export class ChartSettingConfig {
	label = '';
	strokeWidth = 0;
	colorList?: Array<string>;
	stackedValues?: Array<BNEStackedChartConf>;
	labelColor?: string;
	labelFont?: string | number;
	category?: string;
	beforeYAxisFormat?:string = '';
	contentAlign?:string = 'left';
	bulletStyle?:string  = '';
	lableWidth?:string| number = 30;
}

export class BNEStackedChartConf {
	color: string;
	key: string;
	title: string;
	toolTipKey: string;

	constructor(color: string, key: string, title: string, toolTipKey: string) {
		this.color = color;
		this.key = key;
		this.title = title;
		this.toolTipKey = toolTipKey;
	}
}
